import { render } from "./TheButton.vue?vue&type=template&id=05072a18&scoped=true"
const script = {}

import "./TheButton.vue?vue&type=style&index=0&id=05072a18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05072a18"]])

export default __exports__